import React, { Component } from "react";
import Link from "react-router-dom/Link";
import { Icon, Col, Row } from "antd";
import "./Header.css";
// import headerImg from '../../images/webopt-doctor-563429.jpg';
import logoMedWhite from "../../images/logo-med-white.png";
// import AlertHeadline from '../../common/AlertHeadline/AlertHeadline';

class Header extends Component {
  state = {
    header: "Header--container",
    headerOpacity: 1,
  };

  render() {
    return (
      <div className={this.state.header}>
        <div className="Header--headline-container"></div>
        <div className="Header--headline-inner-container">
          <div className="Header--biglogo">
            <img
              src={logoMedWhite}
              alt="Logo med size"
              className="Header--biglogo-img"
            />
          </div>
          <div className="Header--headline">Real Time Touch</div>
          <div className="Header--subheadline">
            "the Missing Link in Telemedicine"
          </div>
        </div>

        <div className="Header--bullet-container">
          <h3 className="Header--bullet1">
            Introducing: a new technology paradigm...
          </h3>
          <h3 className="Header--bullet2">
            Remote simulated physical interaction for
          </h3>
          <h3 className="Header--bullet3">
            the Global Telehealth & Telemedicine market
          </h3>
        </div>

        <div className="Header--box-container">
          <div
            className="Header--box-inner"
          >
            <Link to="/remoterx/">
              <img
                alt="Rx Remote Dispenser"
                className="img-rounded img-responsive"
                style={{ maxWidth: 450 }}
                src="https://www.realtimetouch.com/images/remoterx/RDS1-15BWx450-cropped.png"
              />
            </Link>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                // border: "3px solid green",
              }}
            >
              {/* <Link to="/covid19/">
                  <div className="Header--learnmore-box zoomin" style={{position:'relative', top:10, backgroundColor:"#00ff00", marginRight:10}}>
                    <span style={{textDecoration:0, color:"black", padding: "4px 0" }}>COVID-19</span>
                  </div>
                </Link> */}

              <Link to="/remoterx/">
                <div
                  className="Header--learnmore-box zoomin"
                  style={{ justifyContent: "center", top: 0 }}
                >
                  <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" />
                  <span style={{ textDecoration: 0 }}>Remote Rx Dispenser</span>
                </div>
              </Link>
            </div>
          </div>

          {/* <Link to="/contact/">
            <div className="Header--learnmore-box zoomin"><span style={{textDecoration:0}}><Icon type="user-add" /> Partner with us now!</span></div>
          </Link> */}
          <div
            className="socialbar"
            style={{
              // border: "2px solid blue",
              position: "relative",
              top: -180,
            }}
          >
            <div style={{ marginTop: 10 }}>
              <a href="https://twitter.com/RttCraig">
                <div className="Header--box">
                  <Icon
                    type="twitter"
                    className="Header--box-icon"
                    style={{ color: "#1DA1F2" }}
                  />
                  <span className="Header--social-label">
                    {" "}
                    Craig Linden Twitter
                  </span>
                </div>
              </a>
              <a href="https://www.linkedin.com/in/craig-linden-a093595">
                <div className="Header--box">
                  <Icon
                    type="linkedin"
                    className="Header--box-icon"
                    style={{ color: "#1DA1F2" }}
                  />
                  <span className="Header--social-label">
                    {" "}
                    Craig Linden LinkedIn
                  </span>
                </div>
              </a>
            </div>
            <div style={{ marginTop: 20 }}>
              <a href="https://twitter.com/realtimetouch">
                <div className="Header--box">
                  <Icon
                    type="twitter"
                    className="Header--box-icon"
                    style={{ color: "#1DA1F2" }}
                  />
                  <span className="Header--social-label">RTT Twitter</span>
                </div>
              </a>
              <a href="https://www.facebook.com/realtimetouch/">
                <div className="Header--box">
                  <Icon
                    type="facebook"
                    className="Header--box-icon"
                    style={{ color: "#3B5998" }}
                  />
                  <span className="Header--social-label">RTT Facebook</span>
                </div>
              </a>
              <a href="https://www.linkedin.com/company/realtimetouch/">
                <div className="Header--box">
                  <Icon
                    type="linkedin"
                    className="Header--box-icon"
                    style={{ color: "#3B5998" }}
                  />
                  <span className="Header--social-label">RTT LinkedIn</span>
                </div>
              </a>
            </div>
          </div>
          <div className="Header--moreinfo">
            <p style={{ marginBottom: 3 }}>Scroll down for more info</p>
            <Icon
              type="caret-down"
              className="Header--box-icon-caretdown"
              style={{ color: "#CE001B", fontSize: 22 }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/containers/Header/Header.js